import * as React from "react";
import { Header, SpaceBetween, Toggle } from "@amzn/awsui-components-react";
import { UIModel } from "../../../../../model/ui-model";
import { AdvancedListContent } from "@amzn/ask-legal-domain";
import { AdvancedList } from "@amzn/altar-sds-client";

export const DisplayConfiguration = (props: {
  state: UIModel.State<AdvancedListContent>;
  advancedList: AdvancedList;
}) => {
  const wordWrapFromState = props.state.value.displayConfiguration?.wordWrap ?? false;
  const [wordWrapEnabled, setWordWrapEnabled] = React.useState(wordWrapFromState);

  const handleToggle = (checked: boolean) => {
    setWordWrapEnabled(checked);
    props.state.setValue(
      AdvancedListContent.updateDisplayConfiguration({
        content: props.state.value,
        displayConfiguration: {
          ...props.state.value.displayConfiguration,
          wordWrap: checked,
        },
      })
    );
  };

  return (
    <SpaceBetween direction="vertical" size="s">
      <Header variant="h2">Display Configuration</Header>
      <Toggle
        onChange={({ detail }) => handleToggle(detail.checked)}
        checked={wordWrapEnabled}
        description="Toggle to enable word wrap for text columns"
      >
        Word wrap
      </Toggle>
    </SpaceBetween>
  );
};
